var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from 'react';
var Animate = function (_a) {
    var animationProps = _a.animationProps, containerClasses = _a.containerClasses;
    var ref = useRef(null);
    var _b = __read(useState(null), 2), lottie = _b[0], setLottie = _b[1];
    useEffect(function () {
        void import('lottie-web').then(function (Lottie) {
            setLottie(Lottie.default);
        });
    }, []);
    useEffect(function () {
        if (lottie && ref.current) {
            var animation_1 = lottie.loadAnimation(__assign({ container: ref.current, renderer: 'svg', loop: true, autoplay: true }, animationProps));
            return function () {
                animation_1.destroy();
            };
        }
        return function () { };
    }, [lottie]);
    return React.createElement("div", { ref: ref, className: containerClasses });
};
export default Animate;
//# sourceMappingURL=Animate.js.map